import { RECEIPT_PAYMENT_MODE_ID, TSelectedSkuItem } from "@elixir/types";
import React from "react";
import { NewAptSelectServiceUi } from "ui";
import ServicesPopup from "../../../molecules/cards/queue/services-popup";
import { track } from "../../../utils/tracking";
import { APPOINTMENT_PAYMENT_STATUS_V1 } from ".";
import usePostCreateServicesMaster from "../../../apis/axon/services/use-post-create-services-master";

type TSelectedServiceProps = {
  selectedServiceSkus: TSelectedSkuItem[];
  setSelectedServiceSkus: React.Dispatch<
    React.SetStateAction<TSelectedSkuItem[]>
  >;
  selectedPaymode: RECEIPT_PAYMENT_MODE_ID;
  handleSetSelectedPaymode: (paymode: RECEIPT_PAYMENT_MODE_ID) => void;
  paymentStatusMode?: boolean;
  quickReceiptMode?: boolean;
  selectedPaymentStatus?: APPOINTMENT_PAYMENT_STATUS_V1;
  onPaymentStatusChange?: (
    status: APPOINTMENT_PAYMENT_STATUS_V1 | undefined
  ) => void;
  clinicId?: string;
};

const AddNewSelectedServices = ({
  selectedServiceSkus,
  setSelectedServiceSkus,
  selectedPaymode,
  handleSetSelectedPaymode,
  paymentStatusMode,
  quickReceiptMode,
  selectedPaymentStatus,
  clinicId,
  onPaymentStatusChange,
}: TSelectedServiceProps) => {
  const [openServiceListPopup, setOpenServiceListPopup] =
    React.useState<boolean>(false);

  const { mutateAsync: postCreateService, isLoading: isCreateLoading } =
    usePostCreateServicesMaster({ clinic_id: clinicId as string });

  const handleOnServiceClick = async (serviceSku: TSelectedSkuItem) => {
    track("select_service", {});
    const existingIndex = selectedServiceSkus.findIndex(
      (s) =>
        s.service_id === serviceSku.service_id && s.price === serviceSku.price
    );

    if (existingIndex >= 0) {
      setSelectedServiceSkus((prev) => [
        ...prev.slice(0, existingIndex),
        ...prev.slice(existingIndex + 1),
      ]);
    } else {
      setSelectedServiceSkus((prev) => [...prev, serviceSku]);
    }
  };

  const handleCreateNewService = async (serviceSku: TSelectedSkuItem) => {
    await postCreateService({
      price: serviceSku.price || 0,
      service_name: serviceSku.service_name,
      clinic_id: clinicId as string,
    });
  };

  const handleSkuPriceUpdate = (updatedSku: TSelectedSkuItem) => {
    setSelectedServiceSkus((prev) =>
      prev.map((s) => (s.service_id === updatedSku.service_id ? updatedSku : s))
    );
  };

  return (
    <>
      <NewAptSelectServiceUi
        selectedServiceSkus={selectedServiceSkus}
        openServiceListPopup={openServiceListPopup}
        setOpenServiceListPopup={setOpenServiceListPopup}
        setSelectedSku={handleOnServiceClick}
        onSkuPriceUpdate={handleSkuPriceUpdate}
        selectedPaymode={selectedPaymode}
        setSelectedPaymode={handleSetSelectedPaymode}
        ServicesPopupContent={
          <ServicesPopup
            onClose={() => setOpenServiceListPopup(false)}
            selectedServiceSkus={selectedServiceSkus}
            handleOnServiceClick={handleOnServiceClick}
            onCreateNewService={handleCreateNewService}
          />
        }
        paymentStatusMode={paymentStatusMode}
        quickReceiptMode={quickReceiptMode}
        //@ts-ignore
        selectedPaymentStatus={selectedPaymentStatus}
        onPaymentStatusChange={onPaymentStatusChange}
      />
    </>
  );
};

export default AddNewSelectedServices;
